export default __webpack_public_path__ + "static/media/bell.d4459ae0.mp3";